<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>期刊</span><span style="color:#D7230C;">阅读</span></div>
							<div class="sm_pub">期刊阅读</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">报刊期刊</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom" v-loading="loading">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title">{{contents.title}}</div>
						<!-- 上传者信息 -->
						<div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.uid}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${contents.username}`.substring(3,4)}}</span>
						</div>
						<div style="height: 600px;width: 400px;margin: 0 auto;margin-top: 15px;">
							<img :src="'https://admin.shipoe360.com/public/' + contents.picture"
								style="width: 100%;height: 100%;">
						</div>
						<!-- 内容渲染 -->
						<div class="cont_dtiail" style="height: 230px;overflow: scroll;" v-html="contents.content">
						</div>

					</div>
					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div class="scname" @click="sca"
							style="width: 50px;height: 30px;line-height: 30px;background-color: red;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;margin-left: 17%;margin-top: 10px;float: left;">
							收藏
						</div>
						<el-image-viewer v-if="previewImg" :on-close="closeViewer" :on-switch="onSwitch"
							:url-list="pdfimg">
						</el-image-viewer>

						<div class="scname" @click="zxyd(contents)"
							style="width: 100px;height: 30px;line-height: 30px;background-color: red;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;margin-left: 3%;margin-top: 10px;float: left;margin-left: 10px;">
							在线阅读
						</div>
						<div class="scname" @click="zxdg(contents.qk_money,contents.title)"
							style="width: 100px;height: 30px;line-height: 30px;background-color: red;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;margin-left: 3%;margin-top: 10px;float: left;margin-left: 10px;">
							在线订购
						</div>
						<div style="height: 50px;width: 350px;float: left;margin-left: 15px;">
							<div style="float: left;line-height: 50px;">选择期刊期数:</div>
							<el-select v-model="values" placeholder="选择期数"
								style="float: left;margin-top: 5px;margin-left: 10px;">
								<el-option @click.native="sba(item)" v-for="(item,index) in qbe" :key="index"
									:label="'第'+item.qk_count+'期'" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<!-- <div class="scname" @click="xz(contents.qk_pdf)"
							style="width: 100px;height: 30px;line-height: 30px;background-color: darkorange;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;margin-left: 3%;margin-top: 10px;float: left;margin-left: 10px;">
							下载PDF
						</div> -->
					</div>
					<div style="width: 95%;margin: 0 auto;height: 140px;border-top: 1px dashed #ddd;">

					</div>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>


		</div>
		<dashang ref="dashang"></dashang>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

	export default {

		data() {
			return {
				imgList: ['https://tse1-mm.cn.bing.net/th?id=OIP.fLI-fIeiAEMZwLhz6KkcMQAAAA&w=201&h=200&c=7&o=5&pid=1.7',
					'https://tse1-mm.cn.bing.net/th?id=OIP.fLI-fIeiAEMZwLhz6KkcMQAAAA&w=201&h=200&c=7&o=5&pid=1.7',
					'https://tse1-mm.cn.bing.net/th?id=OIP.fLI-fIeiAEMZwLhz6KkcMQAAAA&w=201&h=200&c=7&o=5&pid=1.7',
					'https://tse1-mm.cn.bing.net/th?id=OIP.fLI-fIeiAEMZwLhz6KkcMQAAAA&w=201&h=200&c=7&o=5&pid=1.7',
					'https://tse1-mm.cn.bing.net/th?id=OIP.fLI-fIeiAEMZwLhz6KkcMQAAAA&w=201&h=200&c=7&o=5&pid=1.7'
				],
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				contents: '',
				qbe: '',
				loading: true,
				values: '',
				numPages: 1,
				previewImg: false,
				pdfimg: [],
				qk_pdfimg:[],
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			async sba(item) {
				this.id = item.id
				this.getinfo();
				// this.$router.push({
				// 	path: '/bgqkdetail',
				// 	query: {
				// 		id: item.id,
				// 		title: item.title
				// 	}
				// })
				
			},
			closeViewer() {
				this.previewImg = false
			},
			onSwitch(e) {
				let that = this
				console.log(that.contents)
				if (e == 0) {
					this.previewImg = false
					this.$confirm('订阅后可查看全部内容?', '提示', {
						confirmButtonText: '去订阅',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.zxdg(that.contents.qk_money, that.contents.title)
					}).catch(() => {

					});
				}
				console.log(e)
			},


			async zxyd(val) {
				let that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let ff = await http.post('api/picture/login_yz', {
						tid: this.contents.title,
						nologin_type: 'qkyd',
						uid: loginInfo.id
					})
					if (ff.data.code == 500) {

						this.pdfimg = [];
						this.qk_pdfimg.forEach((item,index)=>{
							if(index<3){
								this.pdfimg.push(item.url)
							}
						})
						this.previewImg = true;

					} else {
						let routeUrl = this.$router.resolve({
						        path: '/pdf?pdf='+this.contents.qk_pdf+'&title='+this.contents.title+'&id='+this.contents.id,
						      });
						      window.open(routeUrl.href, "_blank");

						// this.$router.replace('/pdf?pdf='+this.contents.qk_pdf+'&title='+this.contents.title+'&id='+this.contents.id)
						// window.open('https://admin.shipoe360.com/public/' + val)
					}
				}else{
					this.pdfimg = [];
					this.qk_pdfimg.forEach((item,index)=>{
						if(index<3){
							this.pdfimg.push(item.url)
						}
					})
					this.previewImg = true;
				}

				// this.$router.replace('/pdf?pdf='+this.contents.qk_pdf+'&title='+this.contents.title+'&id='+this.contents.id)

			},
			zxdg(price = 0, tid) {
				// window.open(val)
				this.$refs.dashang.DS_ck(price, '下载', 'qkyd', tid)
			},
			xz(url) {
				this.fileLinkToStreamDownload('https://admin.shipoe360.com/public/' + url)
			},
			fileLinkToStreamDownload(url) {
				console.log(url)
				let fileName = this.getDay()
				let xhr = new XMLHttpRequest()
				xhr.open('get', url, true)
				xhr.setRequestHeader('Content-Type', `application/pdf`)
				xhr.responseType = 'blob'
				let that = this
				xhr.onload = function() {
					if (this.status == 200) {
						//接受二进制文件流
						var blob = this.response
						that.downloadExportFile(blob, fileName)
					}
				}
				xhr.send()
			},
			downloadExportFile(blob, tagFileName) {
				let downloadElement = document.createElement('a')
				let href = blob
				if (typeof blob == 'string') {
					downloadElement.target = '_blank'
				} else {
					href = window.URL.createObjectURL(blob) //创建下载的链接
				}
				downloadElement.href = href
				downloadElement.download =
					tagFileName +
					//下载后文件名
					document.body.appendChild(downloadElement)
				downloadElement.click() //点击下载
				document.body.removeChild(downloadElement) //下载完成移除元素
				if (typeof blob != 'string') {
					window.URL.revokeObjectURL(href) //释放掉blob对象
				}
			},
			getDay() {
				let time = new Date(),
					year = time.getFullYear(),
					month = time.getMonth() + 1,
					day = time.getDate(),
					timeStem = time.getTime()
				return `${year}/${month}/${day}/${timeStem}.pdf`
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: this.contents.title,
					picture: this.contents.picture,
					pc_link: this.$route.path + '?id=' + this.id,
					url_link: 'pages/detailsofjuice/index?id=' + this.id,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},

			async getinfo() {
				this.loading = true;
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('index.php/bscard/wxapp.Sorts')
				this.options = res.data.data
				console.log(this.id)
				let res1 = await http.post('api/picture/personl_periodical_detail', {
					id: this.id,
					// uid: loginInfo.id
				})
				this.contents = res1.data.data.list
				this.qk_pdfimg = this.contents.qk_pdfimg?JSON.parse( this.contents.qk_pdfimg ):[];
				console.log(this.contents)
				this.qbe = this.contents.tj
				console.log(this.qbe)
				this.values = this.contents.id
				this.loading = false
			},
		},
		mounted() {
			this.getinfo();


			//  let loadingTask = pdf.createLoadingTask('https://admin.shipoe360.com/public/'+this.contents.qk_pdf)
			//  loadingTask.promise.then(pdf => {
			// this.numPages= pdf.numPages
			//  }).catch(err => {
			// console.error('pdf 加载失败', err);
			//  })
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			//打赏
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
			
			ElImageViewer
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1350px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		height: 1350px;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		height: 1350px;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}
</style>
